/**
 * Patrimônio sempre em maiúsculas e sem espaços (decisão da fase 1 do inventário próprio):
 * "rlmp 042" → "RLMP042". Sem isso, o mesmo equipamento digitado de dois jeitos virava dois
 * cadastros, com o histórico partido. Hífen/outros caracteres são mantidos (o SI digita o
 * hostname, que é a fonte do patrimônio). Vazio → null.
 */
export function normalizarPatrimonio(valor: string | null | undefined): string | null {
  if (valor == null) return null;
  const normalizado = valor.replace(/\s+/g, '').toUpperCase();
  return normalizado || null;
}
